<template>
  <div class="node-menu">
    <button
      class="green"
      v-if="!extended && nodeType === 'object'"
      @click.stop="() => handleAddChildClick('convert-object')"
    >
      { <font-awesome-icon :icon="'key'" /> }
    </button>
    <button
      class="green"
      v-if="!extended && nodeType === 'object'"
      @click.stop="() => handleAddChildClick('convert-array')"
    >
      { <font-awesome-icon :icon="'list'" /> }
    </button>
    <button
      class="green"
      v-if="extended && nodeType !== 'object'"
      @click.stop="() => handleAddChildClick('text')"
    >
        T
    </button>
    <button
      class="green"
      v-if="extended"
      @click.stop="() => handleAddChildClick('keyPair')"
    >
      <font-awesome-icon :icon="'key'" />
    </button>
    <button
      class="green"
      v-if="extended"
      @click.stop="() => handleAddChildClick('array')"
    >
      <font-awesome-icon :icon="'list'" />
    </button>
    <button class="blue" @click.stop="handleCopyClick">
        <font-awesome-icon :icon="'copy'" />
    </button>
    <button class="red" @click.stop="handleDeleteClick" v-if="nodeId !== 'root'">
        <font-awesome-icon :icon="'trash'" />
    </button>
  </div>
</template>

<script>
export default {
  name: "nodemenu",
  props: [
    "nodeId",
    "rootObject",
    "handleAddChild",
    "handleMove",
    "menuItemClick",
    "extended"
  ],
  methods: {
    handleAddChildClick(type) {
      this.handleAddChild(type, this.nodeId);
    },
    handleCopyClick() {
      this.menuItemClick("copy", this.nodeId, this.rootObject);
    },
    handleDeleteClick() {
      this.menuItemClick("delete", this.nodeId, this.rootObject);
    },
    handleMoveClick(direction) {
      this.handleMove(direction, this.nodeId);
    },
  },
  computed: {
    nodeType () {
      if (
        Array.isArray(this.rootObject) ||
        typeof this.rootObject === 'object' && 
          Object.values(this.rootObject).length === 1 &&
            Array.isArray(Object.values(this.rootObject)[0])
      ) return 'array'
      return typeof this.rootObject
    }
  }
};
</script>

<style lang='scss' scoped>
.node-menu {
  display: flex;
  padding-left: 15px;
  & button {
    padding: 5px 10px;
    margin-right: 5px;
    color: #fff;
    white-space: nowrap;
    &:hover {
      background-color: rgb(77, 77, 77);
    }
  }
}
</style>